import { AllCountryValues } from '@cbinsights/cbientityservice/cbientityservice';
import { request } from 'client/modules/common/utils/request';

export const getAllCountryValues = (): Promise<AllCountryValues> => {
  return request({
    url: '/service/cbientityservice/GetAllCountryValues',
  }).then((r): AllCountryValues => r.body);
};
